import {
  aCategory,
  anEntityCriticalityConfigPage,
  anInsightStatus,
  aTeamPage,
  aUserPage,
  mockFilterQueryOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

import { RECORD_SCHEMA_JSON } from '@sbu/configs.mocks';

// New, In Progress & Closed Statuses are Built-In
// and are expected to exist for certain integration tests
const NEW_STATUS_NAME = 'new';
const NEW_STATUS_DISPLAY_NAME = 'New';

const IN_PROGRESS_STATUS_NAME = 'inprogress';
const IN_PROGRESS_STATUS_DISPLAY_NAME = 'In Progress';

const CLOSED_STATUS_NAME = 'closed';
const CLOSED_STATUS_DISPLAY_NAME = 'Closed';

export const insightStatusesIncludeClosed = [
  anInsightStatus({
    id: '0',
    name: NEW_STATUS_NAME,
    displayName: NEW_STATUS_DISPLAY_NAME,
  }),
  anInsightStatus({
    id: '1',
    name: IN_PROGRESS_STATUS_NAME,
    displayName: IN_PROGRESS_STATUS_DISPLAY_NAME,
  }),
  anInsightStatus({
    id: '2',
    name: CLOSED_STATUS_NAME,
    displayName: CLOSED_STATUS_DISPLAY_NAME,
  }),
];

export const filterQuery_includeClosed = mockFilterQueryOperationQuery(
  async ({ query: _query, variables: _variables }) => {
    await delay(1500);
    return HttpResponse.json({
      data: {
        __typename: 'Query',
        categories: [aCategory()],
        entityCriticalityConfigs: anEntityCriticalityConfigPage(),
        insightStatuses: insightStatusesIncludeClosed,
        recentlyVisitedSearchQueryPages: [],
        recordSchema: JSON.stringify(RECORD_SCHEMA_JSON),
        teams: aTeamPage(),
        users: aUserPage(),
      },
    });
  }
);

export const handlers = [
  mockFilterQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          categories: [aCategory()],
          entityCriticalityConfigs: anEntityCriticalityConfigPage(),
          insightStatuses: [
            anInsightStatus({
              id: '0',
              name: NEW_STATUS_NAME,
              displayName: NEW_STATUS_DISPLAY_NAME,
            }),
            anInsightStatus({
              id: '1',
              name: IN_PROGRESS_STATUS_NAME,
              displayName: IN_PROGRESS_STATUS_DISPLAY_NAME,
            }),
          ],
          recentlyVisitedSearchQueryPages: [],
          recordSchema: JSON.stringify(RECORD_SCHEMA_JSON),
          teams: aTeamPage(),
          users: aUserPage(),
        },
      });
    }
  ),
];
